<template>
  <div class="home">
    <div class="top">
      <!-- <div class="gonggao">
        <div class="left">企业介绍</div>
        <div class="right">
          <div
            class="text"
            v-for="(item, i) in qiyejieshao"
            :key="i"
            @click="handelFildContract(item.url)"
          >
            {{ item.text }}
          </div>
        </div>
      </div> -->
    </div>
    <div class="bottom">
      <div class="content">
        <div class="data">
          <div class="biaoti">
            <span
              v-for="(item, i) in linedata"
              :key="i"
              @click="handelChangeActive(i, item.left, item.width)"
              :class="{ biaoti_text: true, active2: index == i }"
            >
              {{ item.title }}&ensp;&nbsp;
            </span>
            <div
              class="active1"
              :style="{ left: left + 'px', width: width + 'px' }"
            ></div>
          </div>
          <ul>
            <li
              v-for="(item, i) in messageData"
              :key="i"
              @click="handelFildContract(item.url)"
            >
              <span class="text">{{ item.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%">
      <iframe style="width: 100%; height: 800px" :src="pdfUrl"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import qiyejieshao from "@/homeFiles/qiyejieshao.js";
// import messageGkml from "@/homeFiles/messageGkml.js";
import messageGknb from "@/homeFiles/messageGknb.js";
import messageGkzn from "@/homeFiles/messageGkzn.js";
import yewuBlzn from "@/homeFiles/yewuBlzn.js";
import electrictPbz from "@/homeFiles/electrictPbz.js";
import getpriceXmbz from "@/homeFiles/getpriceXmbz.js";
import getelectrictZl from "@/homeFiles/getelectrictZl.js";
import zhengceFg from "@/homeFiles/zhengceFg.js";
import fuwuGf from "@/homeFiles/fuwuGf.js";
import dianwangKkfyl from "@/homeFiles/dianwangKkfyl.js";
import guanfangJfqd from "@/homeFiles/guanfangJfqd.js";
import marketInfo from "@/homeFiles/marketInfo.js";

export default {
  mounted() {
    this.qiyejieshao = qiyejieshao;
  },
  watch: {
    index: {
      handler(newval, oldval) {
        switch (newval) {
          case 0:
            this.messageData = zhengceFg;
            break;
          case 1:
            this.messageData = electrictPbz;
            break;
          case 2:
            this.messageData = messageGkzn;
            break;
          case 3:
            this.messageData = yewuBlzn;
            break;
          case 4:
            this.messageData = messageGknb;
            break;
          case 5:
            this.messageData = getpriceXmbz;
            break;
          case 6:
            this.messageData = getelectrictZl;
            break;
          case 7:
            this.messageData = fuwuGf;
            break;
          case 8:
            this.messageData = dianwangKkfyl;
            break;
          case 9:
            this.messageData = marketInfo;
            break;
          case 10:
            this.messageData = guanfangJfqd;
            break;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      src: require("@/assets/imgs/qukuailian.jpg"),
      index1: require("@/assets/imgs/index1.jpg"),
      dialogVisible: false,
      pdfUrl: "",
      news: [
        {
          text: "绿色能源空中运输",
          time: "2023-03-06",
        },
        {
          text: "公司召开新型数字基础建设工作推进会",
          time: "2023-03-06",
        },
        {
          text: "塞上“风光”绿电交易",
          time: "2023-03-06",
        },
        {
          text: "公司党委传达学习贯彻习近平总书记重要讲话精神",
          time: "2023-03-06",
        },
        {
          text: "北京市委政府、国务院国资委主要领导赴国网通信产业集团调研",
          time: "2023-03-06",
        },
        {
          text: "北京市委政府、国务院国资委主要领导赴国网通信产业集团调研",
          time: "2023-03-06",
        },
      ],
      linedata: [
        {
          title: "政策法规",
          left: -2,
          width: 63,
        },
        {
          title: "电价标准",
          left: 66,
          width: 66,
        },
        {
          title: "信息公开指南",
          left: 140,
          width: 90,
        },
        {
          title: "业务办理指南",
          left: 239,
          width: 90,
        },
        {
          title: "信息公开年报",
          left: 338,
          width: 90,
        },
        {
          title: "收费项目及指标",
          left: 438,
          width: 104,
        },
        {
          title: "供电质量",
          left: 551,
          width: 63,
        },


        // {
        //   title: "信息公开目录",
        //   left: 652,
        //   width: 90,
        // },
        {
          title: "服务规范",
          left: 622,
          width: 64,
        },
        {
          title: "电网可开放容量及受限情况",
          left: 693,
          width: 176,
        },
        {
          title: "受电工程市场信息",
          left: 877,
          width: 118,
        },
        {
          title: "官方缴费渠道公示",
          left: 1004,
          width: 118,
        },
        // {
        //   title: "信息公开目录",
        //   left: 652,
        //   width: 90,
        // },
        // {
        //   title: "服务规范",
        //   left: 752,
        //   width: 63,
        // },
        // {
        //   title: "电网可开放容量及受限情况",
        //   left: 824,
        //   width: 175,
        // },
        // {
        //   title: "受电工程市场信息",
        //   left: 1006,
        //   width: 122,
        // },
        // {
        //   title: "官方缴费渠道公示",
        //   left: 1134,
        //   width: 122,
        // },
      ],
      index: 0,
      left: -2,
      width: 63,
      qiyejieshao: [],
      messageData: [],
    };
  },
  methods: {
    handelChangeActive(num, left, width) {
      this.index = num;
      this.left = left;
      this.width = width;
    },
    handelFildContract(url) {
      this.pdfUrl = url;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  .top {
    width: 100%;
    height: 400px;
    /* background: #e4eeec; */
    background: url("../../assets/imgs/index1.jpg") no-repeat;
    background-size: cover;
    background-position: 0;
    overflow: hidden;
    position: relative;
    .gonggao {
      width: 1300px;
      height: 40px;
      position: absolute;
      left: calc(50% - 650px);
      bottom: 0;
      display: flex;
      .left {
        background: #059776;
        width: 120px;
        height: 100%;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        font-weight: 700;
      }
      .right {
        cursor: pointer;
        width: calc(100% - 120px);
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f2f2f2;
        font-size: 16px;
        .text {
          margin-left: 16px;
        }
      }
    }
  }
  .bottom {
    width: 100%;
    min-height: calc(100% - 400px);
    background: #f4f4f4;
    .content {
      width: 1300px;
      height: 267px;
      margin: 0 auto;
      display: flex;
      .data {
        width: 100%;
        height: 100%;
        // text-align: center;
        .biaoti {
          width: 100%;
          height: 28px;
          line-height: 24px;
          border-bottom: 4px solid #0aa07a;
          padding-left: 10px;
          box-sizing: border-box;
          position: relative;
          .biaoti_text {
            cursor: pointer;
            color: #9ca6a4;
            font-size: 14px;
          }
          .active2 {
            color: #000;
          }
          .active1 {
            position: relative;
            width: 90px;
            height: 4px;
            background: #f6b442;
            left: 0;
            top: -1px;
            transition: 0.1s linear;
          }
        }
        ul {
          width: 100%;
          height: calc(100% - 28px);
          list-style: none;
          padding-left: 10px;
          padding-right: 24px;
          box-sizing: border-box;
          overflow-x: hidden;
          li {
            cursor: pointer;
            line-height: 1;
            margin-top: 16px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
